/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordResetRequestBody
 */
export interface PasswordResetRequestBody {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequestBody
     */
    password: string;
}

export function PasswordResetRequestBodyFromJSON(json: any): PasswordResetRequestBody {
    return PasswordResetRequestBodyFromJSONTyped(json, false);
}

export function PasswordResetRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordResetRequestBodyToJSON(value?: PasswordResetRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

